<template>
	<div>
		<div class="org-header">
		<h3 class="d-flex align-items-center gap-2">
			<span class="fw-semibold">{{ $route.query.project_name }}</span>
			<span class="text-muted fw-light">&gt;</span>
			<span class="text-muted fs-5 fw-normal">Vulnerabilities</span>
		</h3>

			<div class="mt-4">
				<div class="row">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body">
								<div class="row mb-4">
									<div class="col-md-11 col-9">
										<input type="search" class="form-control w-100 pe-4 rounded-pill" placeholder="Search.." name="" disabled="true">
									</div>
									<div class="col">
										<button type="button" class="btn btn-text" id="btnReport" v-on:click="init()">
											<span class="fas fa-redo"></span>
										</button>
									</div>
								</div>
								<div v-if="Object.keys(reports).length != 0">
									<div class="card mb-2 mt-2" v-for="(rep, i) in reports" :key="i">
										<div class="card-body">
											<h3 v-if="i == 0">Loading vulnerabilities, Please wait<span class="">...</span></h3>
											<div v-else>
												<h3>{{ i }}</h3>
												<table class="table">
													<thead>
														<tr>
															<th>Title</th>
															<th class="text-center">Evidence</th>
															<th>Risk</th>
															<th>&nbsp;</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="r in rep"
															:key="r.ID"
														>
															<td
																:data-bs-toggle="offcanvas"
																data-bs-target="#viewReportSidebar"
																data-bs-keyboard="false"
																aria-controls="offcanvasExample"
																v-on:click="fullReport(r.ID)"
																width="50%"
																class="cursor"
															>
															<span class="badge rounded-pill me-3"
																v-bind:class="{
																	'bg-danger': (r.status == 1),
																	'bg-warning': (r.status == 2),
																	'bg-success': (r.status == 0),
																}"
															>#{{ r.ID }}</span>
															{{ r.title }}
															</td>
															<td class="text-center">
																<div v-if="Object.keys(r.picture).length != 0">
																	<div v-if="r.picture[0].picture != ''">
																		<i class="fa fa-check" title="with evidence"></i>
																	</div>
																</div>
															</td>
															<td>
																<div
																	class="badge vtx-pill"
																	v-bind:class="{
																		'vtx-veryhigh' : (r.risk == 'Very high'),
																		'vtx-high' : (r.risk == 'High'),
																		'vtx-medium' : (r.risk == 'Medium'),
																		'vtx-low' : (r.risk == 'Low'),
																		'vtx-insignificant' : (r.risk == 'Insignificant'),
																	}"
																>{{ r.risk }}</div>
															</td>
															<td v-if="isSuperAdmin || isPentester">
																<button class="btn btn-text text-warning"
																	v-on:click="EditfullReport(r.ID)"
																	data-bs-toggle="modal"
																	data-bs-target="#EditVulnerability"
																	>
																		<i class="far fa-edit"></i>
																</button>

																<button v-on:click="deleteReport(r.ID)" class="btn btn-text text-danger btn-sm">
																	<i class="fa fa-trash"></i>
																</button>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
								<div class="card mb-2 mt-2" v-else>
									<div class="card-body">
										<h3>No vulnerability found</h3>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="offcanvas offcanvas-end offcanvas-lg"
			data-bs-scroll="true"
			data-bs-backdrop="false"
			data-bs-keyboard="false"
			tabindex="-1"
			id="viewReportSidebar">

			<div class="offcanvas-header">
				<button type="button"
					class="btn-close text-reset"
					data-bs-dismiss="offcanvas"
					v-on:click="closeCanvas"
					aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				<viewReport :report_id="report_id" v-if="report_id != 0" :key="reload"/>
			</div>

		</div>

		<!-- edit report -->
		<div class="modal" id="EditVulnerability" tabindex="-2" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h3>Edit Vulnerability</h3>
						<button type="button" id="closeEditForm" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">

						<Submit
							v-if="refresh != 0"
							v-on:callback="submitCallback"
							:project_id="project_id"
							:report_id="report_id"
							:key="refresh" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex'
	import viewReport from './ViewReport.vue'
	import Submit from './Submit.vue'
	export default {
		components: {
			viewReport,
			Submit
		},
		data() {
			return {
				reports: [{}],
				report_id: 0,
				reload: Math.random(),
				project_id: parseInt(this.$route.params.prod_id),
				offcanvas: 'offcanvas',
				refresh: 0
			}
		},
		mounted() {
			this.init();
		},
		computed: {
			...mapGetters({
				isSuperAdmin: 'auth/isSuperAdmin',
				isPentester: 'auth/isPentester'
			})
		},
		methods: {
			init() {
				const me = this;
				this.$axios.get(this.$server + 'organisation/'+ me.$route.params.org_id +'/project/'+ me.$route.params.prod_id +'/report')
				.then(res => {
					var r = res.data;
					if (r.success) {
						me.reports = r.reports;
					} else {
						me.$notifications.notify({
							message: '<span>' + r.message + '</span>',
							icon: 'fa fa-warning',
							type: 'danger'
						});
					}
				});
			},

			fullReport(id) {

				// if (this.$role.isSuperAdmin() || this.$role.isPentester()) {
					this.report_id = id;
					this.reload = Math.random();
					// prevent from
					this.offcanvas = '';
				// } else {
				// 	this.$router.push({ path: '/' + this.$route.params.org_id +'/vulnerability/'+ this.$route.params.prod_id +'/' + id });

				// }
			},

			closeCanvas() {
				this.offcanvas = 'offcanvas';
			},

			EditfullReport(id) {
				this.report_id = id;
				this.refresh = Math.random();
			},


			submitCallback(res) {
				if (res) {
					document.getElementById("closeEditForm").click();
					this.init();
				}
			},

			deleteReport(id){
				var c = confirm("Do you really want to delete this record?");
				if (c) {
					const me = this;
					this.$axios.delete(this.$server + 'organisation/'+ me.$route.params.org_id +'/project/'+ me.$route.params.prod_id +'/report/' + id)
						.then(res => {
						var r = res.data;
						if (r.success) {
						// reload data
							this.init();

							me.$swal({
								title: r.message
							});
						}
					});
				}
			}
		}
	}
</script>